{
  "hangarsPresenter": {
    "title": "Hangares – {{fboName}}",
    "stats": {
      "totalHangars": "Total de hangares",
      "totalAircraft": "Total de aeronaves en hangares"
    },
    "columns": {
      "hangarName": "Nombre hangar",
      "aircraft": "Aeronave",
      "utilization": "Utilización",
      "estValue": "Valor est.",
      "estTowTime": "Remolq. est.",
      "lastStacked": "Últ. apilado",
      "actions": "Acciones"
    },
    "tooltips": {
      "aircraftCount": "# aeronaves en hangar / # aeronaves deseadas",
      "utilization": {
        "title": "Utilización",
        "stacked": "<strong>Apilado</strong> muestra la utilización actual, que puede superar el 100% cuando las aeronaves están estacionadas en el espacio negativo de las dimensiones de otras aeronaves.",
        "fullLoad": "<strong>Con ocupación completa</strong> muestra cuál sería la utilización si todas las aeronaves asignadas a este hangar estuvieran en tierra al mismo tiempo.",
        "gauge": "El indicador muestra un marcador base en 100% - azul por debajo, verde por encima.",
        "adjust": "Ajusta cómo se calcula en Configuración → Configuración"
      },
      "estValue": "Valor estimado del hangar por noche según aeronaves completamente dentro del hangar",
      "estValueBreakdown": "Base: ${{base}} | Trans: ${{transient}}",
      "estTowTime": "Tiempo estimado para posicionar el hangar de remolque"
    },
    "emptyState": {
      "title": "Sin hangares aún",
      "description": "Crea tu primer hangar para comenzar a gestionar el almacenamiento y las operaciones de apilamiento de aeronaves."
    }
  },
  "utilizationDisplay": {
    "stacked": "apilado",
    "atFullTenantLoad": "a capacidad máxima"
  },
  "multiHangarSelector": {
    "label": "Seleccionar hangares",
    "selectAll": "Selec. todo",
    "goButton": "Ir",
    "noHangars": {
      "primary": "No hay hangares disponibles",
      "secondary": "Crea un hangar primero para usar esta función"
    }
  },
  "hangarRow": {
    "aircraftCount": "{{inside}} / {{total}} aeronaves",
    "lastStacked": {
      "tooltip": "Fecha de la última operación de configuración",
      "never": "Nunca"
    },
    "buttons": {
      "currentHangar": "Hangar actual",
      "hangarSchedule": "Programación de hangar",
      "editTenants": "Editar inquilinos"
    }
  }
}
